﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function selectionContainerBlock(context) {
  const select = context.querySelector('.selectioncontainerblock__selection__select select');
  const panels = context.querySelector('.selectioncontainerblock__items');
  
  function init() {
    panels.querySelectorAll('.selectionitemblock').forEach((panel, index) => {
      panel.setAttribute('data-index', index + 1);
    });
    select.addEventListener('change', (e) => {
      const value = e.target.value;
      showCorrespondingPanel(value);
    });
  }

	function showCorrespondingPanel(selectedValue) {
    const currentSelection = panels.querySelector('.selectionitemblock:not([aria-hidden])');
    const newSelection = panels.querySelector(`div[data-index="${selectedValue}"]`);
    
    if (currentSelection)
      currentSelection.setAttribute('aria-hidden', 'true');

    if(newSelection)
      newSelection.removeAttribute('aria-hidden');
	}

  return {
    init
  };
}

controller.add('selectioncontainerblock', selectionContainerBlock);